var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"menu-props":{ bottom: true, offsetY: true }}},'v-select',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }